var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "viewer-thumbnails"
  }, _vm._l((_vm.canvases), function(canvas) {
    return _c('li', {
      staticClass: "viewer-thumbnails__item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.updateSelection(canvas)
        }
      }
    }, [_c('clazy-load', {
      attrs: {
        "src": _vm.getThumbnailImage(canvas)
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getThumbnailImage(canvas)
      },
      slot: "image"
    }), _vm._v(" "), _c('div', {
      staticClass: "preloader"
    }, [_vm._v("\n          Loading...\n        ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(canvas.label))])], 1)])
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7025096","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/Thumbnails.vue
// module id = 0+6Z
// module chunks = 0